import { roundDecimals as V } from "@project-rouge/rg-core";
import { Vector3 as o, MathUtils as l } from "three";
import { getLineDirection as g } from "../../geometry-utils/core/index8.js";
import { SignedAngle as p } from "../../utils/index32.js";
import { Vectors as b } from "../../utils/index36.js";
import { RgDefaultCreate as j } from "../../utils/index28.js";
const d = new o(), i = new o(), s = new o(), u = new o(), D = new o();
function S({
  lines: t,
  thickness: n,
  height: A,
  rvDataList: h = [],
  partial: w
}) {
  const f = [];
  for (let e = 0; e < t.length; e++) {
    const r = t[e], m = e === t.length - 1 ? t[0] : t[e + 1];
    d.fromArray(r[0]), i.fromArray(r[1]), g(r, s), g(m, u);
    const a = V(p(s, u) * l.RAD2DEG, 0);
    D.fromArray(m[1]);
    let c = 0;
    a === 90 && D.equals(i) ? c = -n : a === -90 && (c = n);
    const O = {
      ...structuredClone(w),
      pos: [r[0][0], 0, r[0][2]],
      anchor: [0, 0, 1],
      size: [d.distanceTo(i) + c, A, n],
      rot: [0, -p(s, b.Right) * l.RAD2DEG, 0],
      children: []
    }, R = j(O, h);
    f.push(R);
  }
  return f;
}
export {
  S as createRgObjectsOnLines
};
//# sourceMappingURL=index.js.map
